import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var GamingPad02 = function GamingPad02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6 12h4m-2-2v4m7-1h.01M18 11h.01M5.2 18h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.4802 22 15.9201 22 14.8V9.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 6 19.9201 6 18.8 6H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 7.5198 2 8.08 2 9.2v5.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 18 4.08 18 5.2 18"
    })
  }));
};
export default GamingPad02;